import type { FamilyPlanSnapshot } from "@safesphere/contracts";

export const fictionalPlanId = "fictional-family-plan";
const updatedAt = "2026-09-28T00:00:00.000Z";

export function createEmptyFamilyPlanSnapshot(label: string): FamilyPlanSnapshot {
  return {
    schemaVersion: 1,
    plan: {
      id: fictionalPlanId,
      schemaVersion: 1,
      label,
      fictionalFixture: false,
      updatedAt: new Date().toISOString(),
    },
    contacts: [],
    meetingPoints: [],
    checklists: [],
    protectedRecords: [],
  };
}

export function createFictionalFamilyPlanSnapshot(): FamilyPlanSnapshot {
  return {
    schemaVersion: 1,
    plan: {
      id: fictionalPlanId,
      schemaVersion: 1,
      label: "Fictional household plan",
      fictionalFixture: true,
      updatedAt,
    },
    contacts: [
      {
        id: "fictional-contact",
        planId: fictionalPlanId,
        name: "Fictional out-of-area contact",
        relationshipLabel: "Test fixture",
        contactValue: "000-000-0000 (fictional)",
        updatedAt,
      },
    ],
    meetingPoints: [
      {
        id: "fictional-meeting-point",
        planId: fictionalPlanId,
        label: "Fictional meeting point",
        locationNote: "Placeholder location — not a real address",
        updatedAt,
      },
    ],
    checklists: [
      {
        id: "fictional-evacuation-checklist",
        planId: fictionalPlanId,
        kind: "EVACUATION",
        title: "Fictional evacuation checklist",
        items: [
          {
            id: "fictional-evacuation-item",
            label: "Placeholder checklist item",
            completed: false,
          },
        ],
        updatedAt,
      },
      {
        id: "fictional-go-bag-checklist",
        planId: fictionalPlanId,
        kind: "GO_BAG",
        title: "Fictional go-bag checklist",
        items: [{ id: "fictional-go-bag-item", label: "Placeholder bag item", completed: false }],
        updatedAt,
      },
      {
        id: "fictional-pet-checklist",
        planId: fictionalPlanId,
        kind: "PET",
        title: "Fictional pet-preparedness checklist",
        items: [{ id: "fictional-pet-item", label: "Placeholder pet item", completed: false }],
        updatedAt,
      },
    ],
    protectedRecords: [
      {
        id: "fictional-member",
        planId: fictionalPlanId,
        kind: "MEMBER",
        displayName: "Fictional family member",
        ageGroup: "ADULT",
        allergyPlaceholder: "Fictional allergy placeholder",
        medicationPlaceholder: "Fictional medication placeholder",
        medicalNotePlaceholder: "Fictional medical-note placeholder",
        privateNote: "Fictional private note",
        updatedAt,
      },
      {
        id: "fictional-pet",
        planId: fictionalPlanId,
        kind: "PET",
        displayName: "Fictional pet",
        speciesLabel: "Fictional species",
        careNotePlaceholder: "Fictional care-note placeholder",
        privateNote: "Fictional pet private note",
        updatedAt,
      },
    ],
  };
}
